module.exports = new __parcel__URL__("WhiteboardExperimentSpotlightImage.49c94c1b.svg").toString();